<div class="default-panel mt-2rem mt-xs-max-3">
  <div class="row">
    <div class="col-sm-6">
      <div class="fw-bold font-xl"
           [translate]="'receipt.registerAccount'">Register an account?
      </div>
      <ul class="font-md mt-2 benefits-list">
        <li [translate]="'receipt.registerBenefits.saveHistory'">Save order history</li>
        <li [translate]="'receipt.registerBenefits.saveAddress'">Save your delivery address</li>
        <li [translate]="'receipt.registerBenefits.createReminders'">Create birthday reminders</li>
        <li [translate]="'receipt.registerBenefits.more'">and much more…</li>
      </ul>
    </div>
    <div class="col-sm-6">
      <form #activateUser="ngForm">
        <div class="fw-bold font-xl"
             [translate]="'receipt.justCreatePassword'">Just create a password and you are set!
        </div>
        <div class="mt-2 mb-3">
          <div class="show-password-input-group">
            <input class="form-control"
                   name="password"
                   placeholder="{{'receipt.passwordPlaceholder' | translate}}"
                   required=""
                   [maxlength]="32"
                   [type]="hidePassword ? 'password' : 'text'"
                   [(ngModel)]="password">
            <div class="show-password-icons cursor-pointer"
                 *ngIf="password"
                 (click)="hidePassword =! hidePassword">
              <i class="icon-unpublish font-xl"
                 [class.d-none]="hidePassword"></i>
              <i class="icon-view font-xl"
                 [class.d-none]="!hidePassword"></i>
            </div>
          </div>
        </div>
        <div *ngIf="!alreadySubscriber">
          <ui-checkbox [(model)]="subscribedOnNews">
            <span [innerHTML]="'auth.subscribeOnNews' | translate"></span>
          </ui-checkbox>
        </div>
        <button class="btn btn-outline-pink d-block w-100 mt-3"
                [disabled]="!activateUser.valid"
                (click)="submit()"
                [translate]="'receipt.createAccount'">
          Create account
        </button>
      </form>
    </div>
  </div>
</div>